<template>
  <div id="app">
    <div
      id="ReminderBox"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ReminderBox"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="lbl_ReminderTitle" class="modal-title">
              {{ $t("Reminder") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="lbl_ReminderContent" class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                {{ errormessage }}
              </div>
            </div>

            <div class="form-row">
              <button
                class="btn btn-primary col-md-8"
                @click="onReminderCancel()"
                style="margin: auto"
              >
                {{ errormessage2 }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <canvas id="load" ref="load"></canvas>
    <div class="main-wrapper container">
      <Navbar
        :iconAction="
          action2 == 1 || action2 == 4 || action2 == 2 || action2 == 3 ? 0 : 1
        "
        :changeurl="changeurl()"
      ></Navbar>

      <nav
        class="navbar navbar-secondary"
        style="background-color: initial; box-shadow: 0 0px 0px rgb(0 0 0 / 0%)"
      >
        <div class="container">
          <ul class="navbar-nav">
            <h3 ref="title">{{ title }}</h3>
          </ul>
        </div>
      </nav>

      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-body">
            <div class="card col-md-6" style="margin: auto">
              <div class="card-header">
                <h4>{{ $t("Validation") }}</h4>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <div>
                      <span
                        >{{
                          $t("The verification code has been sent to").replace(
                            "[text]",
                            "+" + (country_code != "" ? country_code : "***")
                          )
                        }}
                      </span>
                      <span id="phone" ref="phone">{{ displayVal }}</span>
                    </div>
                    <div
                      id="otp"
                      ref="otp"
                      class="inputs d-flex flex-row justify-content-center mt-2"
                      v-show="count_error <= 2 && jsready"
                    >
                      <input
                        class="m-2 text-center form-control rounded"
                        name="code"
                        style="padding: 1px 2px"
                        type="tel"
                        inputmode="numeric"
                        id="first"
                        ref="first"
                        maxlength="7"
                        pattern="[0-9]*"
                        v-show="jsready"
                        autocomplete="one-time-code"
                      />
                      <input
                        class="m-2 text-center form-control rounded"
                        name="code"
                        style="padding: 1px 2px"
                        type="tel"
                        inputmode="numeric"
                        id="second"
                        ref="second"
                        maxlength="7"
                        pattern="[0-9]*"
                        v-show="jsready"
                        autocomplete="one-time-code"
                      />
                      <input
                        class="m-2 text-center form-control rounded"
                        name="code"
                        style="padding: 1px 2px"
                        type="tel"
                        inputmode="numeric"
                        id="third"
                        ref="third"
                        maxlength="7"
                        pattern="[0-9]"
                        v-show="jsready"
                        autocomplete="one-time-code"
                      />
                      <input
                        class="m-2 text-center form-control rounded"
                        name="code"
                        style="padding: 1px 2px"
                        type="tel"
                        inputmode="numeric"
                        id="fourth"
                        ref="fourth"
                        maxlength="7"
                        pattern="[0-9]"
                        v-show="jsready"
                        autocomplete="one-time-code"
                      />
                      <input
                        class="m-2 text-center form-control rounded"
                        name="code"
                        style="padding: 1px 2px"
                        type="tel"
                        inputmode="numeric"
                        id="fifth"
                        ref="fifth"
                        maxlength="7"
                        pattern="[0-9]"
                        v-show="jsready"
                        autocomplete="one-time-code"
                      />
                      <input
                        class="m-2 text-center form-control rounded"
                        name="code"
                        style="padding: 1px 2px"
                        type="tel"
                        inputmode="numeric"
                        id="sixth"
                        ref="sixth"
                        maxlength="7"
                        pattern="[0-9]"
                        v-show="jsready"
                        autocomplete="one-time-code"
                      />
                    </div>
                    <span
                      id="validaterror"
                      ref="validaterror"
                      style="color: red; font-size: 10px"
                    ></span
                    ><span
                      id="validaterror"
                      ref="validaterror"
                      style="color: red; font-size: 10px"
                    ></span>
                  </div>
                </div>

                <button
                  class="btn btn-primary col-md-12"
                  id="sumbit"
                  ref="sumbit"
                  @click="sumbit()"
                  :disabled="disabled2"
                  v-if="count_error <= 2"
                >
                  <span
                    v-if="spinner"
                    style="margin-right: 5px"
                    class="spinner-border spinner-border-sm"
                    id="spin"
                    ref="spin"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span id="loading" ref="loading">{{ $t("Validation") }}</span>
                </button>
                <hr/>
                <div id="mcaptcha__widget-container"></div>
                <div class="form-row">
                  <div
                    class="form-group col-md-6"
                    style="margin-bottom: 5px; padding-top: 4px"
                    v-if="count_error <= 2"
                  >
                    <p style="padding-top: 10px" id="demo" ref="demo">
                      {{ demo }}
                    </p>
                  </div>
                  <div
                    class="form-group col-md-6"
                    style="margin-bottom: 5px; padding-top: 10px"
                  >

                    <button class="btn btn-primary col-md-12"
                            id="resend" ref="resend" :disabled="true" @click="pre_send('')">
                      <span
                          v-if="spinner2"
                          style="margin-right: 5px"
                          class="spinner-border spinner-border-sm"
                          id="spin2"
                          ref="spin2"
                          role="status"
                          aria-hidden="true"
                      ></span>
                      <span id="resending" ref="resending">{{
                          $t("Resend validation code")
                        }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>


<style>
canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>



<script>
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";
import config from "@/config";
import Navbar from "@/components/Navbar.vue";
// import VueRecaptcha from 'vue-recaptcha';
import * as mCaptcha from '@mcaptcha/vanilla-glue';

export default {
  components: {Navbar},
  data() {
    return {
      jsready: false,
      errormessage: "",
      errormessage2: "",
      title: "",
      count_error: 0,
      disabled: true,
      disabled2: false,
      phone: null,
      country_code: null,
      k11vipcode: null,
      k11accountno: null,
      kdpmembernumber: null,
      countDownDate: null,
      x: null,
      now: null,
      action: null,
      distance: null,
      minutes: null,
      seconds: null,
      spinner: false,
      spinner2: false,
      login: null,
      action2: null,
      sms_log_id: null,
      type: null,
      demo: "",
      displayVal: "",
      callbackurl: null,
      keycode: null,
      hostname: false,
      token: "",
      McaptchaSitekey:"",
      McaptchaURL:"",
    };
  },
  created() {
    this.hostname = window.location.hostname.indexOf("k11") > -1;
    this.actionSetForceBlock(false);
    this.phone = window.sessionStorage.getItem("phone");
    this.callbackurl = window.sessionStorage.getItem("callbackurl");
    this.country_code = window.sessionStorage.getItem("country_code");
    this.k11vipcode = window.sessionStorage.getItem("k11vipcode");
    this.k11accountno = window.sessionStorage.getItem("k11accountno");
    this.kdpmembernumber = window.sessionStorage.getItem("kdpmembernumber");
    this.action = window.sessionStorage.getItem("action");
    this.action2 = window.sessionStorage.getItem("action2");
    if (this.action2 == 4 || this.action2 == 1 || this.action2 == 2) {
      this.type = "1";
    } else {
      this.type = "2";
    }
    this.sms_log_id = window.sessionStorage.getItem("sms_log_id");
    window.sessionStorage.clear();
    window.localStorage.setItem("counter", 0);
    if (this.phone == null) {
      window.location.href = "./#/";
    } else {
      if (this.phone != "") {
        this.displayVal = "*****" + this.phone.slice(5, this.phone.length);
      } else {
        this.displayVal = "********";
      }
    }
    this.title = this.$t("Verification");
  },
  updated() {
    let vm = this;
    if (vm.action2 == 6) {
      $(vm.$refs.title)[0].innerHTML = vm.$t("Login KDP Account");
    } else if (vm.action2 == 2 || vm.action2 == 3) {
      $(vm.$refs.title)[0].innerHTML = vm.$t("Register KLUB 11 Account");
    } else if (vm.action2 == 5) {
      $(vm.$refs.title)[0].innerHTML = vm.$t("Register KDP Account");
    } else {
      $(vm.$refs.title)[0].innerHTML = vm.$t("Login KLUB 11 Account");
    }
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock"]),
  },
  mounted() {
    let vm = this;
    this.McaptchaSitekey = 'LDwRutV1teBB2w7NBxviGsjthQQBBvgD'
    const instanceUrl = this.hostname ? `https://${window.location.hostname}` : "https://kdp-mh-uat.k11.com";
    this.McaptchaURL = `${instanceUrl}/widget/?sitekey=${this.McaptchaSitekey}`;
    mCaptcha.default({
      widgetLink: new URL(this.McaptchaURL)
    })
    $(document).ready(function () {
      if (vm.action2 == 6) {
        $(vm.$refs.title)[0].innerHTML = vm.$t("Login KDP Account");
      } else if (vm.action2 == 2 || vm.action2 == 3) {
        $(vm.$refs.title)[0].innerHTML = vm.$t("Register KLUB 11 Account");
      } else if (vm.action2 == 5) {
        $(vm.$refs.title)[0].innerHTML = vm.$t("Register KDP Account");
      } else {
        $(vm.$refs.title)[0].innerHTML = vm.$t("Login KLUB 11 Account");
      }
      (function ($) {
        $.fn.inputFilter = function (inputFilter) {
          return this.on(
            "input keydown keyup mousedown mouseup select contextmenu drop",
            function () {
              if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
              } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(
                  this.oldSelectionStart,
                  this.oldSelectionEnd
                );
              } else {
                this.value = "";
              }
            }
          );
        };
      })(jQuery);

      setTimeout(function () {
        $(vm.$refs.phone_num).inputFilter(function (value) {
          return /^\d*$/.test(value); // Allow digits only, using a RegExp
        });
        // Set the date we're counting down to
        vm.countDownDate = new Date().getTime() + 180000;
        // Update the count down every 1 second
        vm.x = setInterval(function () {
          // Get today's date and time
          vm.now = new Date().getTime();
          // Find the distance between now and the count down date
          vm.distance = vm.countDownDate - vm.now;

          // Time calculations for days, hours, minutes and seconds
          vm.minutes = Math.floor(
            (vm.distance % (1000 * 60 * 60)) / (1000 * 60)
          );
          vm.seconds = Math.floor(vm.distance / 1000);

          // Display the result in the element with id="demo"
          vm.demo = vm
            .$t("The code is only valid in")
            .replace("[text]", vm.seconds);
          // " " +
          // vm.minutes +
          // vm.$t("m ") +
          // vm.seconds +
          // vm.$t("s ");

          // If the count down is finished, write some text
          if (vm.distance < 0) {
            clearInterval(vm.x);
            vm.$refs.resend.disabled = false;
            vm.disabled2 = true;
            vm.demo = vm.$t(
              "Your verification code has expired, please try again"
            );
          }
        }, 1000);

        var enter_function = document.getElementsByName("code");
        for (let i = 0; i < enter_function.length; i++) {
          enter_function[i].addEventListener("keydown", function (e) {
            if (e.keyCode === 13) {
              event.preventDefault();
              if (!vm.disabled2) {
                vm.sumbit();
              }
            }
          });
        }
        vm.OTPInput();
      }, 1000);

      // $("#first,#second,#third,#fourth,#fifth,#sixth").on("input", function () {
      //   var pastedData = $(this).val();
      //   if (pastedData.length != 1 && pastedData.length != 7) {
      //     const inputs = document.querySelectorAll("#otp > *[id]");
      //     for (let i = 0; i < pastedData.length && i < 6; i++) {
      //       inputs[i].value = pastedData[i];
      //     }
      //   } else if (pastedData.length == 7) {
      //     for (let i = 1; i < pastedData.length && i < 7; i++) {
      //       const inputs = document.querySelectorAll("#otp > *[id]");
      //       inputs[i - 1].value = pastedData[i];
      //     }
      //   }
      // });

      //IOS 15 double input bug

      $("#first").on("input", function () {
        // console.log(event.type);
        var pastedData = $(this).val();
        const inputs = document.querySelectorAll("#otp > *[id]");
        if (pastedData.length == 1) {
          // if (vm.keycode == 229) {
          //   inputs[1].value = null;
          //   // vm.keycode = null;
          // } else {
          var input_value = pastedData[0];
          if (input_value >= 0 && input_value <= 9) {
            inputs[0].value = pastedData[0];
            inputs[1].focus();
          } else {
            inputs[0].value = "";
          }
          // }
        } else if (pastedData.length == 2) {
          var input_value = pastedData[1];
          console.log(input_value);
          if (inputs[0].value != "" && inputs[0].value != null) {
            inputs[0].value = pastedData[0];
            if (input_value >= 0 && input_value <= 9) {
              inputs[1].focus();
              inputs[1].value = pastedData[1];
            }
          }
        } else if (pastedData.length == 6) {
          for (let i = 0; i < pastedData.length; i++) {
            inputs[i].value = pastedData[i];
          }
        } else if (pastedData.length == 7) {
          for (let i = 1; i < pastedData.length; i++) {
            inputs[i - 1].value = pastedData[i];
          }
        } else if (pastedData.length == 8) {
          for (let i = 2; i < pastedData.length; i++) {
            inputs[i - 2].value = pastedData[i];
          }
        }
        // vm.OTPInput();
        vm.disableinput();
      });

      $("#second").on("input", function () {
        var pastedData = $(this).val();
        const inputs = document.querySelectorAll("#otp > *[id]");

        if (pastedData.length == 1) {
          // if (vm.keycode == 229) {
          //   inputs[2].value = null;
          //   // vm.keycode = null;
          // } else {
          var input_value = pastedData[0];
          if (input_value >= 0 && input_value <= 9) {
            inputs[1].value = pastedData[0];
            inputs[2].focus();
          } else {
            inputs[1].value = "";
          }

          // }
        } else if (pastedData.length == 2) {
          var input_value = pastedData[1];
          if (inputs[1].value != "" && inputs[1].value != null) {
            inputs[1].value = pastedData[0];
            if (input_value >= 0 && input_value <= 9) {
              inputs[2].focus();
              inputs[2].value = pastedData[1];
            }
          }
        }
        // else if (pastedData.length == 2) {
        //   // alert(vm.keycode);
        //   inputs[1].value = pastedData[1];
        // }
        else if (pastedData.length == 6) {
          for (let i = 0; i < pastedData.length; i++) {
            inputs[i].value = pastedData[i];
          }
        } else if (pastedData.length == 7) {
          for (let i = 1; i < pastedData.length; i++) {
            inputs[i - 1].value = pastedData[i];
          }
        } else if (pastedData.length == 8) {
          for (let i = 2; i < pastedData.length; i++) {
            inputs[i - 2].value = pastedData[i];
          }
        }
        // vm.OTPInput();
        vm.disableinput();
      });

      $("#third").on("input", function () {
        var pastedData = $(this).val();
        const inputs = document.querySelectorAll("#otp > *[id]");

        if (pastedData.length == 1) {
          var input_value = pastedData[0];
          if (input_value >= 0 && input_value <= 9) {
            inputs[2].value = pastedData[0];
            inputs[3].focus();
          } else {
            inputs[2].value = "";
          }
        } else if (pastedData.length == 2) {
          var input_value = pastedData[1];
          if (inputs[2].value != "" && inputs[2].value != null) {
            inputs[2].value = pastedData[0];
            if (input_value >= 0 && input_value <= 9) {
              inputs[3].focus();
              inputs[3].value = pastedData[1];
            }
          }
        } else if (pastedData.length == 6) {
          for (let i = 0; i < pastedData.length; i++) {
            inputs[i].value = pastedData[i];
          }
        } else if (pastedData.length == 7) {
          for (let i = 1; i < pastedData.length; i++) {
            inputs[i - 1].value = pastedData[i];
          }
        } else if (pastedData.length == 8) {
          for (let i = 2; i < pastedData.length; i++) {
            inputs[i - 2].value = pastedData[i];
          }
        }
        // vm.OTPInput();
        vm.disableinput();
      });

      $("#fourth").on("input", function () {
        var pastedData = $(this).val();
        const inputs = document.querySelectorAll("#otp > *[id]");

        if (pastedData.length == 1) {
          var input_value = pastedData[0];
          if (input_value >= 0 && input_value <= 9) {
            inputs[3].value = pastedData[0];
            inputs[4].focus();
          } else {
            inputs[3].value = "";
          }
        } else if (pastedData.length == 2) {
          var input_value = pastedData[1];
          if (inputs[3].value != "" && inputs[3].value != null) {
            inputs[3].value = pastedData[0];
            if (input_value >= 0 && input_value <= 9) {
              inputs[4].focus();
              inputs[4].value = pastedData[1];
            }
          }
        } else if (pastedData.length == 6) {
          for (let i = 0; i < pastedData.length; i++) {
            inputs[i].value = pastedData[i];
          }
        } else if (pastedData.length == 7) {
          for (let i = 1; i < pastedData.length; i++) {
            inputs[i - 1].value = pastedData[i];
          }
        } else if (pastedData.length == 8) {
          for (let i = 2; i < pastedData.length; i++) {
            inputs[i - 2].value = pastedData[i];
          }
        }
        // vm.OTPInput();
        vm.disableinput();
      });

      $("#fifth").on("input", function () {
        const inputs = document.querySelectorAll("#otp > *[id]");

        var pastedData = $(this).val();
        if (pastedData.length == 1) {
          var input_value = pastedData[0];
          if (input_value >= 0 && input_value <= 9) {
            inputs[4].value = pastedData[0];
            inputs[5].focus();
          } else {
            inputs[4].value = "";
          }
        } else if (pastedData.length == 2) {
          var input_value = pastedData[1];
          if (inputs[4].value != "" && inputs[4].value != null) {
            inputs[4].value = pastedData[0];
            if (input_value >= 0 && input_value <= 9) {
              inputs[5].focus();
              inputs[5].value = pastedData[1];
            }
          }
        } else if (pastedData.length == 6) {
          for (let i = 0; i < pastedData.length; i++) {
            inputs[i].value = pastedData[i];
          }
        } else if (pastedData.length == 7) {
          for (let i = 1; i < pastedData.length; i++) {
            inputs[i - 1].value = pastedData[i];
          }
        } else if (pastedData.length == 8) {
          for (let i = 2; i < pastedData.length; i++) {
            inputs[i - 2].value = pastedData[i];
          }
        }
        // vm.OTPInput();
        vm.disableinput();
      });

      $("#sixth").on("input", function () {
        var pastedData = $(this).val();
        const inputs = document.querySelectorAll("#otp > *[id]");
        if (pastedData.length == 1) {
          var input_value = pastedData[0];
          if (input_value >= 0 && input_value <= 9) {
            inputs[5].value = pastedData[0];
          } else {
            inputs[5].value = "";
          }
        } else if (pastedData.length == 2) {
          // alert(vm.keycode);
          var input_value = pastedData[1];
          if (input_value >= 0 && input_value <= 9) {
            inputs[5].value = pastedData[1];
          } else {
            inputs[5].value = "";
          }
        } else if (pastedData.length == 6) {
          for (let i = 0; i < pastedData.length; i++) {
            inputs[i].value = pastedData[i];
          }
        } else if (pastedData.length == 7) {
          for (let i = 1; i < pastedData.length; i++) {
            inputs[i - 1].value = pastedData[i];
          }
        } else if (pastedData.length == 8) {
          for (let i = 2; i < pastedData.length; i++) {
            inputs[i - 2].value = pastedData[i];
          }
        }
        // vm.OTPInput();
        vm.disableinput();
      });

      $("#first,#second,#third,#fourth,#fifth,#sixth").bind(
        "paste",
        function (e) {
          var pastedData = e.originalEvent.clipboardData.getData("text");
          const inputs = document.querySelectorAll("#otp > *[id]");
          for (let i = 0; i < pastedData.length && i < 6; i++) {
            inputs[i].value = pastedData[i];
          }
        }
      );
    });

    vm.disabled2 = true;
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest",
    ]),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),
    back() {
      clearInterval(this.x);
    },
    onReminderCancel() {
      $("#ReminderBox").modal("hide");
      if (this.count_error > 2) {
        this.changeurl();
        window.location.href = "./#/";
      }
    },
    changeurl() {
      window.sessionStorage.setItem("callbackurl", this.callbackurl);
    },
    disableinput() {
      // alert(
      //   "a:" +
      //     $(this.$refs.first).val() +
      //     "b:" +
      //     $(this.$refs.second).val() +
      //     "c:" +
      //     $(this.$refs.third).val() +
      //     "d:" +
      //     $(this.$refs.fourth).val() +
      //     "e:" +
      //     $(this.$refs.fifth).val() +
      //     "f:" +
      //     $(this.$refs.sixth).val()
      // );

      var code;
      code =
        $(this.$refs.first).val() +
        $(this.$refs.second).val() +
        $(this.$refs.third).val() +
        $(this.$refs.fourth).val() +
        $(this.$refs.fifth).val() +
        $(this.$refs.sixth).val();
      if (code.length == 6 && this.disabled) {
        this.disabled2 = false;
      } else {
        this.disabled2 = true;
      }
    },
    OTPInput() {
      let vm = this;
      const inputs = document.querySelectorAll("#otp > *[id]");
      //alert("a");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener("keydown", function (event) {
          if (event.keyCode == "37" && i != 0) {
            inputs[i - 1].focus();
            return true;
          } else if (event.keyCode == "39" && i != 5) {
            inputs[i + 1].focus();
            return true;
          } else if (event.key === "Backspace" || event.keyCode == "8") {
            inputs[i].value = "";
            if (i !== 0) inputs[i - 1].focus();
            vm.disabled2 = true;
            event.preventDefault();
            return true;
          } else {
            if (i === inputs.length - 1 && inputs[i].value !== "") {
              if (
                (event.keyCode > 47 && event.keyCode < 58) ||
                (event.keyCode > 95 && event.keyCode < 106) //||
                //event.keyCode == 229 //for IOS 15 bug
              ) {
                inputs[i].value = event.key;
                event.preventDefault();
                vm.disableinput();
              } else {
                inputs[i].value = "";
                vm.disabled2 = true;
                event.preventDefault();
              }
              return true;
            }
            // else if (
            //   (event.keyCode > 47 && event.keyCode < 58) ||
            //   (event.keyCode > 95 && event.keyCode < 106) //||
            //   //event.keyCode == 229 //for IOS 15 bug
            // ) {
            //   if (inputs[i].value != null && inputs[i].value != "" && i != 5) {
            //     //IOS 15 bug
            //     // alert(event.keyCode + "  !a");

            //     // alert(event.keyCode + "  !c");
            //     if (event.keyCode != 229) {
            //       inputs[i + 1].value = event.key;
            //     }
            //   } else {
            //     // alert(event.keyCode + "  !b");

            //     inputs[i].value = event.key;
            //   }
            //   if (event.keyCode == 229) {
            //     vm.keycode = 229;
            //   }
            //   if (i !== inputs.length - 1) inputs[i + 1].focus(); //IOS 15 bug
            //   // if (event.target.value.length == 1) {
            //   //   if (vm.keycode == 229) {
            //   //     alert("wtf:" + event.target.value);
            //   //     vm.keycode == null;
            //   //   } else {
            //   //     alert("abc:" + event.target.value);
            //   //   }
            //   // }

            //   event.preventDefault();
            //   vm.disableinput();
            //   return true;
            // } else if (event.keyCode == 229) {
            //   // inputs[i].value = "";
            //   alert(event.key);
            //   alert(event.target.value);
            //   vm.disabled2 = true;
            //   event.preventDefault();
            //   return true;
            // }
            else {
              // inputs[i].value = "";
              // vm.disabled2 = true;
              // event.preventDefault();
              return true;
            }
          }
        });
      }
      vm.jsready = true;
    },
    resend() {
      const mcaptcha__token = $('#mcaptcha__token')
      this.token = mcaptcha__token[0]?.value
      const token = this.token;
      let vm = this;
      $.ajax({
        method: "POST",
        contentType: "application/json",
        url: config.serverURI + "/migrationhub/captcha",
        data: JSON.stringify({
          parameters: {
            receiver_value: {
              country_code: this.country_code,
              value: this.phone,
              kdp_member_number: this.kdpmembernumber,
            },
            token: token,
            receiver_type: 2,
            type: this.type,
            action: this.action,
            klub11_vip_code: vm.k11vipcode,
          },
        }),
        complete: function (data) {
          vm.spinner2 = false;
          if (data.responseJSON != null) {
            if (data.responseJSON.success) {
              if (vm.action2 == 2) {
              } else {
                vm.sms_log_id = data.responseJSON.data.sms_log_id;
              }
              vm.$refs.resend.disabled = true;
              window.localStorage.setItem("counter", 0);
              vm.countDownDate = new Date().getTime() + 180000;
              vm.x = setInterval(function () {
                // Get today's date and time
                vm.now = new Date().getTime();
                // Find the distance between now and the count down date
                vm.distance = vm.countDownDate - vm.now;

                // Time calculations for days, hours, minutes and seconds
                vm.minutes = Math.floor(
                  (vm.distance % (1000 * 60 * 60)) / (1000 * 60)
                );
                vm.seconds = Math.floor(vm.distance / 1000);

                // Display the result in the element with id="demo"
                // $(vm.$refs.demo)[0].innerHTML =

                // If the count down is finished, write some text
                if (vm.distance < 0) {
                  clearInterval(vm.x);
                  vm.$refs.resend.disabled = false;
                  // vm.disabled2 = true;
                  // $(vm.$refs.demo)[0].innerHTML =
                  vm.demo = vm.$t(
                    "Your verification code has expired, please try again"
                  );
                }else{
                  vm.demo = vm
                      .$t("The code is only valid in")
                      .replace("[text]", vm.seconds);
                }
              }, 1000);
            } else {
              vm.errormessage = `${vm.$t("Something went wrong")} ${data.responseJSON.msg[helper.getMappingLocale(vm.$i18n.locale)]}(${data.responseJSON.errorcode})`;
              vm.errormessage2 = vm.$t("Back");
              $("#ReminderBox").modal("show");
              vm.spinner = false;
              $(vm.$refs.load).css("z-index", 0);
            }
          } else {
            vm.errormessage = vm.$t("Network error");
            vm.errormessage2 = vm.$t("Back");
            $("#ReminderBox").modal("show");
          }
        },
      });
    },
    pre_send(token) {
      console.log("token2", token);
      if (this.count_error > 2) {
        $(this.$refs.validaterror)[0].innerText = this.$t(
          "You have exceeded the maximum of attempts for resend a verification code, pleace try again later"
        );
        this.errormessage = this.$t(
          "You have exceeded the maximum of attempts for resend a verification code, pleace try again later"
        );
        this.errormessage2 = this.$t("OK");
        this.$refs.resend.disabled = false;

        $("#ReminderBox").modal("show");
        clearInterval(this.x);
      } else {
        this.disabled2 = true;
        this.count_error += 1;
        this.spinner2 = true;
        $(this.$refs.validaterror)[0].innerText = "";
        this.resend(token);
      }
    },
    onVerify(token){
      const mcaptcha__token = $('#mcaptcha__token')
      this.token = mcaptcha__token[0]?.value
      this.token = token;
    },
    sumbit() {
      let vm = this;
      var code;

      code =
        $(this.$refs.first).val() +
        $(this.$refs.second).val() +
        $(this.$refs.third).val() +
        $(this.$refs.fourth).val() +
        $(this.$refs.fifth).val() +
        $(this.$refs.sixth).val();

      document.getElementById("first").value = "";
      document.getElementById("second").value = "";
      document.getElementById("third").value = "";
      document.getElementById("fourth").value = "";
      document.getElementById("fifth").value = "";
      document.getElementById("sixth").value = "";
      $("#first").focus();
      if (code.length == 6 && this.disabled) {
        $(this.$refs.load).css("z-index", "2147483647");
        $(this.$refs.loading)[0].innerText = this.$t("Loading") + " ...";
        this.spinner = true;

        $.ajax({
          method: "POST",
          contentType: "application/json",
          url: config.serverURI + "/migrationhub/member/verification",
          data: JSON.stringify({
            mobile_phone_country: vm.country_code,
            account_value_detail: vm.phone,
            verify_value: code,
            verify_type: (vm.action == "0" && !this.kdpmembernumber)  ? "3" : "2",
            account_type: "2",
            action: vm.action,
            sms_log_id: vm.sms_log_id,
            k11_vip_account_no: this.k11accountno || "",
            klub11_vip_code: this.k11vipcode || "",
            kdp_member_id: this.kdpmembernumber || "",
          }),
          complete: function (data3) {
            const mcaptcha__token = $('#mcaptcha__token')
            this.token = mcaptcha__token[0]?.value
            const token = this.token;
            if (data3.responseJSON != null) {
              if (data3.responseJSON.success) {
                // Member identifiers are only available now, after the
                // OTP/password verification succeeded.
                const vdata = data3.responseJSON.data;
                if (vdata.klub11_vip_code) vm.k11vipcode = vdata.klub11_vip_code;
                if (vdata.klub11_vip_account_number) vm.k11accountno = vdata.klub11_vip_account_number;
                if (vdata.kdp_member_id) vm.kdpmembernumber = vdata.kdp_member_id;
                vm.k11vipcode = vm.k11vipcode || "";
                vm.k11accountno = vm.k11accountno || "";
                vm.kdpmembernumber = vm.kdpmembernumber || "";
                window.sessionStorage.setItem(
                  "session",
                  data3.responseJSON.data.session
                );
                window.sessionStorage.setItem(
                  "phone",
                  data3.responseJSON.data.phone
                );
                window.sessionStorage.setItem(
                  "country_code",
                  data3.responseJSON.data.country_code
                );
                if (vm.action2 == 6) {
                  // window.sessionStorage.setItem("phone", vm.phone);
                  // window.sessionStorage.setItem(
                  //   "country_code",
                  //   vm.country_code
                  // );
                  window.sessionStorage.setItem(
                    "kdpmembernumber",
                    vm.kdpmembernumber
                  );
                  window.sessionStorage.setItem("action2", 0);
                  window.sessionStorage.setItem("action", 0);
                  window.sessionStorage.setItem("k11vipcode", vm.k11vipcode);
                  window.sessionStorage.setItem(
                    "k11accountno",
                    vm.k11accountno
                  );
                  window.sessionStorage.setItem("iskdp", vm.iskdp);
                  window.sessionStorage.setItem("isk11", vm.isk11);
                  vm.changeurl();
                  $(vm.$refs.validaterror)[0].innerText=  ""
                  window.location.href = "./#/login_member";
                } else if (vm.action2 == 5) {
                  // window.sessionStorage.setItem("phone", vm.phone);
                  // window.sessionStorage.setItem(
                  //   "country_code",
                  //   vm.country_code
                  // );
                  window.sessionStorage.setItem("action", 1);
                  window.sessionStorage.setItem("k11vipcode", vm.k11vipcode);
                  window.sessionStorage.setItem(
                    "k11accountno",
                    vm.k11accountno
                  );
                  window.sessionStorage.setItem("iskdp", "0");
                  window.sessionStorage.setItem("isk11", "1");
                  vm.changeurl();
                  $(vm.$refs.validaterror)[0].innerText=  ""
                  window.location.href = "./#/register";
                } else if (vm.action2 == 4) {
                  let check_k11vipcode = vm.k11vipcode.substring(0, 2);
                  if (check_k11vipcode == "01") {
                    clearInterval(vm.x);

                    window.sessionStorage.setItem("action2", vm.action2);
                    // window.sessionStorage.setItem("phone", vm.phone);
                    // window.sessionStorage.setItem(
                    //   "country_code",
                    //   vm.country_code
                    // );
                    window.sessionStorage.setItem("iskdp", 1);
                    window.sessionStorage.setItem("isk11", 1);
                    window.sessionStorage.setItem("action", "1");
                    window.sessionStorage.setItem("k11vipcode", vm.k11vipcode);
                    window.sessionStorage.setItem(
                      "k11accountno",
                      vm.k11accountno
                    );
                    window.sessionStorage.setItem(
                      "kdpmembernumber",
                      vm.kdpmembernumber
                    );

                    vm.changeurl();
                    $(vm.$refs.validaterror)[0].innerText=  ""
                    window.location.href = "./#/login_member";
                  } else {
                    helper.loading();
                    $.ajax({
                      method: "POST",
                      contentType: "application/json",
                      url: config.serverURI + "/migrationhub/captcha",
                      data: JSON.stringify({
                        parameters: {
                          receiver_value: {
                            country_code: vm.country_code,
                            value: vm.phone,
                            kdp_member_number: vm.kdpmembernumber,
                          },
                          token: token,
                          receiver_type: 2,
                          // type: null,
                          action: 0,
                          klub11_vip_code: vm.k11vipcode,
                        },
                      }),
                      complete: function (jdata) {
                        if (jdata.responseJSON != null) {
                          if (jdata.responseJSON.success) {
                            vm.action2 = 6;
                            vm.action = 0;
                            vm.sms_log_id = jdata.responseJSON.data.sms_log_id;
                            vm.count_error = 0;
                            vm.disabled = true;
                            window.localStorage.setItem("counter", 0);
                            vm.countDownDate = new Date().getTime() + 180000;
                            vm.x = setTimeout(function () {
                              setInterval(function () {
                                // Get today's date and time
                                vm.now = new Date().getTime();
                                // Find the distance between now and the count down date
                                vm.distance = vm.countDownDate - vm.now;

                                // Time calculations for days, hours, minutes and seconds
                                vm.minutes = Math.floor(
                                  (vm.distance % (1000 * 60 * 60)) / (1000 * 60)
                                );
                                vm.seconds = Math.floor(vm.distance / 1000);
                              });
                              // Display the result in the element with id="demo"
                              // $(vm.$refs.demo)[0].innerHTML =
                            }, 1000);
                            document.getElementById("first").value = "";
                            document.getElementById("second").value = "";
                            document.getElementById("third").value = "";
                            document.getElementById("fourth").value = "";
                            document.getElementById("fifth").value = "";
                            document.getElementById("sixth").value = "";

                            vm.spinner = false;
                            $(vm.$refs.loading)[0].innerText =
                              vm.$t("Validation");
                            $(vm.$refs.load).css("z-index", 0);
                            $(vm.$refs.validaterror)[0].innerText=  ""
                            helper.done();
                          } else {
                            vm.errormessage =
                              vm.$t("Something went wrong") +
                              // " " +
                              // vm.$t("Please try again later") +
                              " " +
                              jdata.responseJSON.msg[
                                helper.getMappingLocale(vm.$i18n.locale)
                              ] +
                              "(" +
                              jdata.responseJSON.errorcode +
                              ")";
                            $("#ReminderBox").modal("show");
                            helper.done();
                          }
                        } else {
                          vm.errormessage = vm.$t("Network error");
                          $("#ReminderBox").modal("show");
                          helper.done();
                        }
                      },
                    });
                  }
                } else if (vm.action2 == 1) {
                  let check_k11vipcode = vm.k11vipcode.substring(0, 2);
                  if (check_k11vipcode == "01") {
                    clearInterval(vm.x);
                    window.sessionStorage.setItem("action2", vm.action2);
                    // window.sessionStorage.setItem("phone", vm.phone);
                    // window.sessionStorage.setItem(
                    //   "country_code",
                    //   vm.country_code
                    // );
                    window.sessionStorage.setItem("iskdp", 0);
                    window.sessionStorage.setItem("isk11", 1);
                    window.sessionStorage.setItem("action", vm.action);
                    window.sessionStorage.setItem("k11vipcode", vm.k11vipcode);
                    window.sessionStorage.setItem(
                      "k11accountno",
                      vm.k11accountno
                    );
                    window.sessionStorage.setItem(
                      "kdpmembernumber",
                      vm.kdpmembernumber
                    );
                    vm.changeurl();
                    $(vm.$refs.validaterror)[0].innerText=  ""
                    window.location.href = "./#/login_member";
                  } else {
                    $.ajax({
                      method: "POST",
                      contentType: "application/json",
                      url: config.serverURI + "/migrationhub/captcha",
                      data: JSON.stringify({
                        parameters: {
                          receiver_value: {
                            country_code: vm.country_code,
                            value: vm.phone,
                            kdp_member_number: "",
                          },
                          token: token,
                          receiver_type: 2,
                          type: null,
                          action: 0,
                          klub11_vip_code: vm.k11vipcode,
                        },
                      }),
                      complete: function (jdata2) {
                        if (jdata2.responseJSON != null) {
                          if (jdata2.responseJSON.success) {
                            vm.action2 = 5;
                            vm.action = 0;
                            vm.iskdp = 0;
                            vm.isk11 = 1;
                            vm.kdpmembernumber = "";
                            vm.count_error = 0;
                            vm.disabled = true;
                            window.localStorage.setItem("counter", 0);
                            vm.countDownDate = new Date().getTime() + 180000;
                            vm.x = setTimeout(function () {
                              setInterval(function () {
                                vm.now = new Date().getTime();
                                vm.distance = vm.countDownDate - vm.now;

                                vm.minutes = Math.floor(
                                  (vm.distance % (1000 * 60 * 60)) / (1000 * 60)
                                );
                                vm.seconds = Math.floor(
                                  (vm.distance % (1000 * 60)) / 1000
                                );
                              });
                            }, 1000);
                            document.getElementById("first").value = "";
                            document.getElementById("second").value = "";
                            document.getElementById("third").value = "";
                            document.getElementById("fourth").value = "";
                            document.getElementById("fifth").value = "";
                            document.getElementById("sixth").value = "";

                            vm.spinner = false;
                            $(vm.$refs.loading)[0].innerText =
                              vm.$t("Validation");
                            $(vm.$refs.load).css("z-index", 0);
                            helper.done();
                            $(vm.$refs.validaterror)[0].innerText=  ""
                          }
                        } else {
                          vm.errormessage = vm.$t("Network error");
                          $("#ReminderBox").modal("show");
                          vm.spinner = false;
                          $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                          $(vm.$refs.load).css("z-index", 0);
                        }
                      },
                    });
                  }
                } else if (vm.action2 == 2) {
                  clearInterval(vm.x);
                  window.sessionStorage.setItem("action2", vm.action2);
                  // window.sessionStorage.setItem("phone", vm.phone);
                  // window.sessionStorage.setItem(
                  //   "country_code",
                  //   vm.country_code
                  // );
                  window.sessionStorage.setItem("iskdp", 1);
                  window.sessionStorage.setItem("isk11", 0);
                  window.sessionStorage.setItem("action", "0");
                  window.sessionStorage.setItem("k11vipcode", vm.k11vipcode);
                  window.sessionStorage.setItem(
                    "k11accountno",
                    vm.k11accountno
                  );
                  window.sessionStorage.setItem(
                    "kdpmembernumber",
                    vm.kdpmembernumber
                  );
                  vm.changeurl();
                  $(vm.$refs.validaterror)[0].innerText=  ""
                  window.location.href = "./#/login_member";
                } else if (vm.action2 == 3) {
                  clearInterval(vm.x);
                  // window.sessionStorage.setItem("phone", vm.phone);
                  // window.sessionStorage.setItem(
                  //   "country_code",
                  //   vm.country_code
                  // );
                  window.sessionStorage.setItem("action", 0);
                  window.sessionStorage.setItem("iskdp", 0);
                  window.sessionStorage.setItem("isk11", 0);
                  $(vm.$refs.validaterror)[0].innerText=  ""
                  vm.changeurl();
                  window.location.href = "./#/register";
                }
              } else {
                vm.count_error++;
                if (vm.count_error > 2) {
                  $(vm.$refs.validaterror)[0].innerText = vm.$t(
                    "You have exceeded the maximum of attempts for resend a verification code, pleace try again later"
                  );
                  vm.errormessage = vm.$t(
                    "You have exceeded the maximum of attempts for resend a verification code, pleace try again later"
                  );
                  vm.errormessage2 = vm.$t("OK");
                  vm.disabled = false;
                  clearInterval(vm.x);
                } else {
                  $(vm.$refs.validaterror)[0].innerText = vm.$t(
                    "Verification code entered is invalid, please try later"
                  );
                }
                $(vm.$refs.loading)[0].innerText = vm.$t("Validation");
                vm.spinner = false;
                $(vm.$refs.load).css("z-index", "0");
              }
            } else {
              vm.errormessage = vm.$t("Network error");
              vm.errormessage2 = vm.$t("Back");
              $(vm.$refs.loading)[0].innerText = vm.$t("Validation");
              vm.spinner = false;
              $(vm.$refs.load).css("z-index", "0");
            }
            // corrsonding to the four case
          },
        });
      } else {
        vm.count_error++;
        if (vm.count_error > 2) {
          $(vm.$refs.validaterror)[0].innerText = vm.$t(
            "You have exceeded the maximum of attempts for resend a verification code, pleace try again later"
          );
          vm.errormessage = vm.$t(
            "You have exceeded the maximum of attempts for resend a verification code, pleace try again later"
          );
          vm.errormessage2 = vm.$t("OK");
          vm.disabled = false;
          clearInterval(vm.x);
        } else {
          $(vm.$refs.validaterror)[0].innerText = vm.$t(
            "Verification code entered is invalid, please try again"
          );
          // vm.spinner = false;
          // $(vm.$refs.load).css("z-index", "0");
        }
        $(vm.$refs.loading)[0].innerText = vm.$t("Validation");
        vm.spinner = false;
        $(vm.$refs.load).css("z-index", "0");
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.x);
    next();
  },
};
</script>
